import classNames from "classnames";
import { Button, Textarea } from "@/components";
import { useInput } from "@/hooks";
import { useRef, useState } from "react";
import { AiOutlineMore } from "react-icons/ai";
import { FaCaretDown } from "react-icons/fa";
import { Issue as IssueType } from "@/types";

interface Props {
  issue: IssueType;
  dismissReasons: {
    title: string;
    id: any;
    description: string;
  }[];
  className: string;
  onDismiss(
    category: string,
    index: number,
    dismissReason: string,
    comment: string,
  ): Promise<void>;
  width?: number;
}
export const DismissSelect: React.FC<Props> = ({
  issue,
  className,
  dismissReasons = [],
  onDismiss = () => {},
  width,
}) => {
  const [reason, setReason] = useState<string>("");
  const [isExpand, setIsExpand] = useState<boolean>(false);
  const comment = useInput("");
  const [isCommentExpand, setIsCommentExpand] = useState<boolean>(false);

  const actionRef = useRef<HTMLDivElement>(null);

  const handleReasonChange = (
    event: React.MouseEvent<HTMLDivElement>,
    value: string,
  ) => {
    event.stopPropagation();
    setReason(value);
    setIsCommentExpand(true);
  };

  const resetState = () => {
    setIsExpand(false);
    setIsCommentExpand(false);
    setReason("");
    comment.setValue("");
  };

  const cancelDismiss = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    resetState();
  };

  const toggleExpand = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setIsExpand(!isExpand);
  };

  const handleDismissIssue = async () => {
    await onDismiss(issue.type, issue.index - 1, reason, comment.value);
    resetState();
  };

  return (
    <div
      className={classNames("dismiss-select", className)}
      style={{ width: width || "auto" }}
    >
      <div
        className={classNames("dismiss-select__container", {
          active: isExpand,
        })}
        ref={actionRef}
      >
        <div
          className={classNames("dismiss-select__main", {
            active: reason,
          })}
        >
          <div
            className="flex-1 d-flex justify-content-between"
            onClick={toggleExpand}
          >
            <span className="my-auto">Dismiss Issue</span>
          </div>

          <FaCaretDown className="dismiss-select__arrow" />
        </div>
        <div
          className={classNames("dismiss-select__main-mobile", {
            active: reason,
          })}
          onClick={toggleExpand}
        >
          <AiOutlineMore size={24} />
        </div>
        <div
          className={classNames("dismiss-select__menu")}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="dismiss-select__title">Dismiss Issue</div>
          {dismissReasons.map(({ title, id: itemVal, description }) => {
            return (
              <div
                className={classNames("dismiss-select__menu-item", {
                  active: reason === itemVal,
                })}
                onClick={(e) => handleReasonChange(e, itemVal)}
                key={itemVal}
              >
                <div
                  className="d-flex align-items-center justify-content-start"
                  key={itemVal}
                >
                  <span className="dismiss-select__radio"></span>
                  <span className="ms-2">{title}</span>
                </div>
                <div className="dismiss-select__description">{description}</div>
              </div>
            );
          })}
          {isCommentExpand && (
            <div className="dismiss-select__comment">
              <div className="dismiss-select__comment-text">
                Dismissal Comment
              </div>
              <Textarea
                {...comment}
                className="dismiss-select__comment-input"
              />
              <div className="d-flex my-3">
                <Button onClick={handleDismissIssue}>Dismiss</Button>
                <Button className="ms-3" color="light" onClick={cancelDismiss}>
                  Cancel
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
